import * as React from 'react';

function Basketball(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.37 9.022v2.377h8.4a8.75 8.75 0 00-2.134-5.31 9.17 9.17 0 01-6.265 2.933zm-6.576 9.353a8.835 8.835 0 005.622 2.395v-5.085a8.15 8.15 0 00-5.622 2.69zm5.622-3.627v-2.394H3a8.799 8.799 0 002.134 5.327 9.103 9.103 0 016.282-2.933zm.955.937v5.085a8.79 8.79 0 005.605-2.395 8.076 8.076 0 00-5.605-2.69zm-.955-4.286V9.022a9.176 9.176 0 01-6.282-2.933A8.75 8.75 0 003 11.399h8.416zm.955.955v2.394a9.097 9.097 0 016.264 2.933 8.799 8.799 0 002.135-5.327h-8.4zm-.955-4.27V3a8.836 8.836 0 00-5.622 2.395 8.295 8.295 0 005.622 2.69zm6.56-2.69A8.79 8.79 0 0012.371 3v5.085a8.219 8.219 0 005.605-2.69z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Basketball;
